module.exports = __webpack_public_path__ + "img/ep-rectangle-2angles-arrondis.3a3b1564.jpg";